import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import { getSettlementTransactions } from "src/api/accounts";
import { DataTable, type Column } from "src/components/common";
import { renderCurrency } from "src/lib/utils";
import type { SettlementTransactionRow } from "src/types/settlement";

const formatDate = (value?: string) => {
	if (!value) return "—";
	const parsed = new Date(value);
	return Number.isNaN(parsed.getTime()) ? "—" : format(parsed, "Pp");
};

const columns: Column<SettlementTransactionRow>[] = [
	{ key: "sn", header: "S/N", className: "tw-w-[64px]", cell: (_row, index) => index + 1 },
	{ key: "reference", header: "Reference", primary: true, cell: (row) => <span className="tw-break-all">{row.reference ?? "—"}</span> },
	{ key: "amount", header: "Amount", cell: (row) => renderCurrency(row.amount ?? 0) },
	{ key: "date", header: "Date", cell: (row) => formatDate(row.updated_at) },
];

interface SettlementTransactionsProps {
	uuid: string;
}

const SettlementTransactions = ({ uuid }: SettlementTransactionsProps) => {
	const { data, isLoading } = useQuery({
		queryKey: ["settlement-transactions", uuid],
		queryFn: () => getSettlementTransactions({ uuid }),
		suspense: true,
	});

	return (
		<DataTable
			columns={columns}
			data={data?.data?.data ?? []}
			loading={isLoading}
			rowKey={(row, index) => row.uuid ?? index}
			emptyTitle="No transactions"
			emptyDescription="Nothing has settled into this account yet."
		/>
	);
};

export default SettlementTransactions;
